import { useEffect } from "react";

export default function MaintenanceOverlay() {
  useEffect(() => {
    document.body.style.overflow = "hidden";

    return () => {
      document.body.style.overflow = "";
    };
  }, []);

  return (
    <div className="maintenance-overlay">
      <div className="maintenance-content">
        <div/>

        <h1>Scheduled Maintenance</h1>

        <p>
          We are currently performing scheduled maintenance to improve our services.
        </p>

        <p>
          The site will be unavailable until approximately{" "}
          <strong>4 June, 2026 7:00 AM SGT</strong>.
        </p>

        <p>Thank you for your patience.</p>
      </div>
    </div>
  );
}